// extracted by mini-css-extract-plugin
module.exports = {"grids":"CardGrid_grids___oicV","seasons":"CardGrid_seasons__37KkF","grid":"CardGrid_grid__2lNAV"};